import { render, staticRenderFns } from "./AlertIndividualConfigurationOfComponents.vue?vue&type=template&id=35c9996f&scoped=true&lang=pug&"
import script from "./AlertIndividualConfigurationOfComponents.vue?vue&type=script&lang=ts&"
export * from "./AlertIndividualConfigurationOfComponents.vue?vue&type=script&lang=ts&"
import style0 from "./AlertIndividualConfigurationOfComponents.vue?vue&type=style&index=0&id=35c9996f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c9996f",
  null
  
)

export default component.exports